import React, { useContext, useEffect } from 'react';
import { CampaignChallengeBooking, useCampaignChallengesQuery } from '../../generated/graphql';
import FieldTable from '../../components/field-table';
import { useUserContext } from '../../contexts/user-context';
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Button, Tab, Tabs, Typography } from '@mui/material';
import { Circle } from '@mui/icons-material';
import WaitSpinner from '../../components/wait-spinner';
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import { isoDateToMMMWithTime } from '../../utils';
import { format, subDays } from 'date-fns';
import { ToolbarContext } from '../../contexts/toolbar-context';

const columns:FieldTableColumnProps<CampaignChallengeBooking>[] = [
    {header:'',accessor:'status',
    width: 'minmax(1em,max-content)',
    dataType:'text',
    options: {
        renderViewer:({field})=> {
            return (
                field?.value=='OPEN'?<Circle color="info"/>:
                (field?.value=='REJECT'?<Circle color="error"/>:
                <Circle color="success"/>)
            );
        },
    }
    },
    {header:'Site',accessor:'panel.site.name',
    dataType:'text',
        options: {
            getValue:({row})=>{
                return row?.panel?.site?.name+': '+row.panel?.panel;
            }
        }
    },
    {
        header:'Region',
        accessor:'panel.site.region',
        dataType:'text',
        options: {
            getValue:({row})=>{
                return row?.panel?.site?.region?.regionType?.name+' / '+row?.panel?.site?.region?.name;
            }
        }
    },
    {
        header:'Start Date',
        accessor:'date_start',
        dataType:'date'
    },
    {
        header:'Campaign',
        accessor:'targetPanelBooking.campaign.job_reference',
        dataType:'link',
        options: {
            getLink:({row})=>{
                return '/campaigns/' + row.targetPanelBooking?.campaign?.job_reference;
            }
        }
    }
];


export const CampaignChallengeRequests = () => {
    const user = useUserContext();
    const challenges = useCampaignChallengesQuery({variables:{user_id:user?.user?.id,direction:'inbound',markViewed:true},fetchPolicy:'network-only'});
    useEffect(()=>{
        if(challenges && !challenges.loading) {
            challenges.refetch();
        }
    },[user.activeChallengeCountOutbound,challenges]);
    let hasData = false;
    const activeData:JSX.Element[] = [];
    const completedData:JSX.Element[] = [];
    const nowMinusOne = format(subDays(new Date(),1),'yyyy-MM-dd hh:mm:ss');
    const toolbarContext = useContext(ToolbarContext);
    useEffect(() => {
        toolbarContext.setToolbar(
          {
            primary: [],
            title: 'Incoming Challenges',
            secondary: []
          });
      }, []);
    const data = challenges.data?.campaignChallenges?.forEach((challenge)=>{
        hasData = true;
        let pushTo = 'COMPLETED';
        if(challenge?.status=='LIVE') {
            challenge.bookingChallenges?.forEach((v)=>{
                if(v?.status=='OPEN') {
                    pushTo = 'LIVE';
                }
            });
        }
        const filteredChallenges:any|null[] = [];
        // filter rows
        challenge?.bookingChallenges?.forEach((challenge)=>{
            if(challenge?.targetCampaign?.ourContact?.id==user.user?.id ||
                challenge?.targetCampaign?.ourContact?.proxyUser?.id==user.user?.id) {
                filteredChallenges.push(challenge);
            }
        });
        const value =  (<Accordion key={challenge?.id}>
                <AccordionSummary sx={(theme)=>({backgroundColor:((pushTo=='LIVE' && nowMinusOne>challenge?.created_at)?theme.palette.error.dark:theme.palette.primary.dark),
            color:theme.palette.primary.contrastText})}>                    
                    <Typography style={{height:'100%',display:'inline-flex'}}><span> CHALLENGE FROM: &nbsp;
                {challenge?.campaign?.ourContact?.name} / {challenge?.campaign?.name} / {challenge?.campaign?.job_reference}</span>
                <span style={{ position: 'absolute', right: '80px', top: 0, zIndex: 2, backgroundColor: 'inherit', height: '100%', display: 'flex',alignItems:'center' }}>{isoDateToMMMWithTime(challenge.created_at,false)}</span>
                </Typography>
                </AccordionSummary>
                <AccordionDetails>
                <FieldTable values={filteredChallenges??[]} columns={columns} hasDelete={false}
loading={challenges.loading} readOnly={true}
                footer={
                    pushTo=='LIVE' &&<><Button variant="contained" onClick={()=>{window.open('/challenges/'+challenge?.id)}}>Respond</Button></>}
                />
                </AccordionDetails>
        </Accordion>)

        if(pushTo=='LIVE') {
            activeData.push(value);
        } else {
            completedData.push(value);
        }
    });
    const [tab,setTab] = React.useState('LIVE');
    const changeTab = (evt,value)=>{
        setTab(value);
    };
    return <div className="campaign-challenges is-scrollable">
        {!challenges.data && <WaitSpinner variant="panel"/>}
        {challenges.data!=null && hasData &&
        <>
        <Tabs value={tab} onChange={changeTab}>
            <Tab value="LIVE" label="Live challenges"/>
            <Tab value="COMPLETED" label="Completed challenges"/>
        </Tabs>
            {tab == 'LIVE' && activeData}
            {tab=="COMPLETED" && completedData}
            </>
        }
        {challenges.data!=null && !hasData?<Alert severity="success"><AlertTitle>You have no outstanding requests</AlertTitle></Alert>:[]}
    </div>
}